var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVkIconMini = function SvgVkIconMini(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    y: 0.071,
    fill: "#99A2AD",
    rx: 7.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.762 16.57c-5.067 0-8.142-3.38-8.262-9h2.566c.08 4.128 2.033 5.877 3.53 6.237V7.57h2.459v3.562c1.444-.154 2.955-1.774 3.462-3.562h2.421c-.387 2.198-2.032 3.819-3.194 4.487 1.163.54 3.034 1.955 3.756 4.513h-2.66c-.563-1.71-1.939-3.035-3.784-3.215v3.215z"
  })));
};
export default SvgVkIconMini;